module.exports = __webpack_public_path__ + "img/157.f1907116.jpg";